import * as React from 'react';
import { ContainerClient } from '@azure/storage-blob';
import { ConfirmationAsidePanel } from '../AsidePanel/ConfirmationAsidePanel';
import { BlobList } from './BlobList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BlobContainerList(_ref) {
  let {
    containerUrl,
    disabled = false,
    renderListComponent = BlobList,
    path = '',
    onDelete,
    onFilesNumberChange,
    showThumbnail,
    hideDelete = false,
    filter
  } = _ref;
  const [items, setItems] = React.useState([]);
  const [confirmDeletion, setConfirmDeletion] = React.useState(false);
  const [blobName, setBlobName] = React.useState();
  React.useEffect(() => {
    if (onFilesNumberChange && items.length > 0) {
      onFilesNumberChange(items.length, items);
    }
  }, [items.length]);
  const containerClientRef = React.useRef(new ContainerClient(containerUrl));
  const containerClient = containerClientRef.current;
  async function getList() {
    if (!containerClientRef) {
      return;
    }
    const blobs = [];
    const iter = containerClient.listBlobsByHierarchy('/', {
      prefix: "".concat(path, "/")
    });
    let entity = await iter.next();

    // Lifted from the official example found here:
    // https://github.com/Azure/azure-sdk-for-js/blob/619cf8c9717226474a1bacb07eaa6ba146dcc4a2/sdk/storage/storage-blob/samples/typescript/src/iterators-blobs-hierarchy.ts#L71
    while (!entity.done) {
      const item = entity.value;
      if (item.kind !== 'prefix') {
        blobs.push(item);
      }
      entity = await iter.next();
    }
    if (filter) {
      const filteredBlobs = blobs.filter(filter);
      setItems(filteredBlobs);
      return;
    }
    setItems(blobs);
  }
  const deleteBlobByName = async blobItemName => {
    await containerClient.deleteBlob(blobItemName);
    await getList();
    if (onDelete) onDelete();
  };
  const onSelectClick = async blobItemName => {
    const blobClient = containerClient.getBlobClient(blobItemName);
    if (typeof window === 'undefined') {
      return;
    }
    try {
      var _blobItemName$split$p;
      const response = await fetch(blobClient.url);
      if (!response.ok) {
        throw new Error("Failed to fetch blob: ".concat(response.status));
      }
      const blob = await response.blob();
      const downloadUrl = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.download = (_blobItemName$split$p = blobItemName.split('/').pop()) !== null && _blobItemName$split$p !== void 0 ? _blobItemName$split$p : blobItemName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      window.location.href = blobClient.url;
    }
  };
  React.useEffect(() => {
    getList();
  }, []);
  const List = React.useCallback(() => {
    return renderListComponent({
      items: items,
      path: path,
      disabled: disabled,
      onDelete: async blobItemName => {
        setBlobName(blobItemName);
        setConfirmDeletion(true);
      },
      onSelect: onSelectClick,
      showThumbnail,
      containerUrl,
      hideDelete
    });
  }, [items, disabled]);
  const clearDeletionConfirmation = () => {
    setConfirmDeletion(false);
    setBlobName('');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {}), /*#__PURE__*/_jsx(ConfirmationAsidePanel, {
      isOpen: confirmDeletion,
      onConfirmClick: async () => {
        if (blobName) {
          await deleteBlobByName(blobName);
        }
        clearDeletionConfirmation();
      },
      onCancelClick: () => {
        clearDeletionConfirmation();
      }
    })]
  });
}